import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import React from 'react'
import sxs from './_styles/HelpCenterCardsSx'
import sxsButton from './_styles/HelpButtonsSx'
import { HelpCenterCardButtonProps } from './_props'
import { ArrowOutwardIcon } from '../../assets/icons/icons'

const HelpCenterCardButtonClickable: React.FC<HelpCenterCardButtonProps> = ({
    buttonName,
    handleClick,
    colorVariant = 'primary',
}) => (
    <Box sx={sxs.cardAction}>
        <Button
            endIcon={<ArrowOutwardIcon style={sxs.buttonIcon} />}
            sx={[sxsButton.button, colorVariant === 'secondary' ? sxsButton.buttonSecondary : null]}
            onClick={handleClick}
        >
            {buttonName}
        </Button>
    </Box>
)

export default HelpCenterCardButtonClickable
